<template>
    <div>
        <div>
            <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Реестр соискателей</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">Реестр работодателей</a>
                </li>
            </ul>
        </div>


        <div class="tab-content mt-4" id="myTabContent">
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1">
                <applicant-list></applicant-list>
            </div>
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2">
                <vacancy-list></vacancy-list>
            </div>
        </div>
    </div>
</template>
<script>
import ApplicantList from "../components/ApplicantList";
import VacancyList from "../components/VacancyList";

export default {
    name: "VacancyIndex",
    components: {
        ApplicantList, VacancyList
    },
    data() {
        return {
            activeItem: 'tab1',
        }
    },
    created() {
    },
    methods: {
        isActive (menuItem) {
            return this.activeItem === menuItem
        },
        setActive (menuItem) {
            this.activeItem = menuItem
        }
    },
}
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";
.nav-tabs {
  justify-content: center;
  border: none;
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  .nav-item {
    margin-top: 12px;
    max-width: 240px;
    width: 100%;
    min-width: 205px;
    margin-right: 8px;
    margin-left: 8px;
    .nav-link {
      padding: 14.5px 20px;
      text-align: center;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}
</style>